import React from 'react';

import styles from '../../index.module.scss';
import { PreviewBlock, ProgramBlockItem } from '..';
import type { CellConfig, CellData, CellHandlers, CellPosition } from './types';

type TimetableCellProps = {
  position: CellPosition;
  data: CellData;
  config: CellConfig;
  handlers: CellHandlers;
};

export const TimetableCell = ({
  position,
  data,
  config,
  handlers,
}: TimetableCellProps) => {
  const { columnIdx, timeIdx } = position;
  const {
    blocks,
    allColumnBlocks,
    previewBlock,
    draggedBlock,
    selectedBlockId,
  } = data;
  const { showInstructor, scheduleType, enableDrag = false } = config;
  const { onBlockClick, onDragStart, onDragOver, onDragLeave, onDrop } =
    handlers;
  const tdProps = {
    key: columnIdx,
    className: styles.blockTd,
    onDragOver: (e: React.DragEvent<HTMLTableCellElement>) =>
      onDragOver(e, columnIdx, timeIdx),
    onDragLeave: onDragLeave,
    onDrop: (e: React.DragEvent<HTMLTableCellElement>) =>
      onDrop(e, columnIdx, timeIdx),
  };

  if (blocks.length === 0) {
    return (
      <td {...tdProps}>
        {enableDrag &&
          previewBlock &&
          previewBlock.columnIdx === columnIdx &&
          previewBlock.timeIdx === timeIdx &&
          draggedBlock && (
            <PreviewBlock
              draggedBlock={draggedBlock}
              newStart={previewBlock.newStart}
              newEnd={previewBlock.newEnd}
              isRestricted={previewBlock.isRestricted}
              isTimeLimit={previewBlock.isTimeLimit}
            />
          )}
      </td>
    );
  }

  return (
    <td {...tdProps}>
      {enableDrag &&
        previewBlock &&
        previewBlock.columnIdx === columnIdx &&
        previewBlock.timeIdx === timeIdx &&
        draggedBlock && (
          <PreviewBlock
            draggedBlock={draggedBlock}
            newStart={previewBlock.newStart}
            newEnd={previewBlock.newEnd}
            isRestricted={previewBlock.isRestricted}
            isTimeLimit={previewBlock.isTimeLimit}
          />
        )}
      {blocks.map((block) => (
        <ProgramBlockItem
          key={block.id}
          block={block}
          allColumnBlocks={allColumnBlocks}
          selectedBlockId={selectedBlockId}
          showInstructor={showInstructor}
          scheduleType={scheduleType}
          enableDrag={enableDrag}
          onBlockClick={onBlockClick}
          onDragStart={onDragStart}
        />
      ))}
    </td>
  );
};
